export const resolve = (input) => {
  return {
    ...input,
    nonPdFieldType: input?.nonPdFieldType ?? "BI",
  };
};
